import { IHttpService } from "../../core/service/HttpService";
import { formatBooleanValue, parseBooleanValue } from "../../util";
import { ICodebook } from "../model/Codebook";
import { IGenericCodebookItem } from "../model/GenericCodebookItem";

export interface ICodebookService {
  getAllGenericTypes(): Promise<ICodebook[]>;
  createGenericCodebookItem(codebookItem: IGenericCodebookItem): Promise<any>;
  updateGenricCodebookItem(codebookItem: IGenericCodebookItem): void;
  getGenericCodebook(
    codebookType: string,
    includeDeleted: boolean
  ): Promise<IGenericCodebookItem[]>;
}

const CodebookService = ({ httpService }): ICodebookService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _basePath: string = "/codebooks";
  const _genericPath: string = "/generic";
  const _typesPath: string = "/types";

  const CodebookMapper = (json: any = []) => {
    return json.map((item: any) => {
      let data = {} as ICodebook;
      data.name = item;
      return data;
    });
  };
  const GenericCodebookItemMapper = (json: any = []) => {
    return json.map((item: any) => {
      return {
        ...item,
        valid: formatBooleanValue(item.valid)
      };
    });
  };
  const GenericCodebookItemParamsMapper = (
    genericCodebookItem: IGenericCodebookItem
  ) => {
    const { type, ...others } = genericCodebookItem;
    return {
      ...others,
      type: type.toUpperCase(),
      valid: parseBooleanValue(genericCodebookItem.valid)
    };
  };

  return {
    async getAllGenericTypes() {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        _genericPath,
        _typesPath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return CodebookMapper(responseJSON);
    },
    async createGenericCodebookItem(codebookItem: IGenericCodebookItem) {
      const path = _http.buildPath(_baseUrl, _basePath, _genericPath);
      const response = await _http.post(path, {
        params: {
          ...GenericCodebookItemParamsMapper(codebookItem)
        },
        form: true
      });
      return _http.toText(response);
    },
    async updateGenricCodebookItem(codebookItem: IGenericCodebookItem) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        _genericPath,
        codebookItem.id.toString()
      );
      const response = await _http.put(path, {
        params: GenericCodebookItemParamsMapper(codebookItem),
        form: true
      });
      return _http.toText(response);
    },
    async getGenericCodebook(codebookType: string, includeDeleted: boolean) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        _genericPath,
        _typesPath,
        codebookType.toUpperCase()
      );
      const response = await _http.get(path, {
        params: {
          includeDeleted: includeDeleted
        }
      });
      const responseJSON = await _http.toJSON(response);
      return GenericCodebookItemMapper(responseJSON);
    }
  };
};
export default CodebookService;
